import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import FeaturedComics from './components/FeaturedComics';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '香香漫画',
    url: 'https://www.xiangxiangcomic.com/',
    description: '香香漫画网提供香香漫画官网入口与网址，海量韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全，下拉式追更体验。',
    potentialAction: {
      '@type': 'SearchAction',
      'target': 'https://www.xiangxiangcomic.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '香香漫画',
    url: 'https://www.xiangxiangcomic.com/',
    description: '韩漫日漫国漫免费在线阅读平台',
  };

  return (
    <>
      <SEOMeta
        title="香香漫画 - 香香漫画网：香香漫画官网入口与网址，韩漫日漫国漫免费在线阅读"
        description="香香漫画网提供香香漫画官网入口与网址，海量韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全，下拉式追更体验，安全直达。香香漫画，您的免费漫画阅读天堂。"
        keywords="香香漫画,香香漫画网,香香漫画官网入口,香香漫画网址,韩漫免费阅读,日漫,国漫,漫画全集,下拉式,追更,好看的漫画,免费漫画大全"
        canonicalUrl="https://www.xiangxiangcomic.com/"
        schema={{ ...schema, ...orgSchema }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <HotRanking />
        <LatestUpdates />
        <FeaturedComics />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              为什么选择香香漫画？
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mb-10 max-w-2xl mx-auto">
              我们致力于为漫画爱好者提供最优质的在线阅读体验
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {[
                { icon: 'ri-book-read-line', title: '海量资源', desc: '韩漫日漫国漫，持续更新收录' },
                { icon: 'ri-arrow-down-circle-line', title: '下拉追更', desc: '流畅的下拉式阅读，追更不等待' },
                { icon: 'ri-shield-check-line', title: '安全直达', desc: '无广告干扰，纯净阅读环境' },
                { icon: 'ri-heart-line', title: '完全免费', desc: '所有漫画免费阅读，无需付费' },
              ].map((item) => (
                <div key={item.title} className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-3xl p-8 md:p-12 text-center">
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
                开启你的漫画之旅
              </h2>
              <p className="text-background-200 text-sm md:text-base mb-6 max-w-lg mx-auto">
                海量韩漫日漫国漫等你来发现，立即开始免费阅读
              </p>
              <a
                href="/category"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-base hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
              >
                立即探索
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}